/* Millie & Jones menu (October 2026).
   Desktop: panels open on hover (mouse only, short delay to stop flicker), on click of the arrow
   button, and from the keyboard; Escape, a click outside or moving focus away closes them.
   Phone: the <dialog> drawer slides in from the left; sections open one at a time.
   Clicks on [data-mj-menu] are sent to Microsoft Clarity as a "menu_click" event with the item
   as a tag, so menu use can be checked before changing it again. */
(function () {
  'use strict';
  if (window.__mjMenu) return;
  window.__mjMenu = true;

  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 180;
  var desktopMq = window.matchMedia('(min-width: 1200px)');
  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Desktop panels ---------- */
  var openItem = null;
  var timers = new WeakMap();

  function parts(item) {
    return {
      toggle: item.querySelector('[data-mjn-toggle]'),
      panel: item.querySelector('[data-mjn-panel]')
    };
  }
  function clearTimer(item) {
    var t = timers.get(item);
    if (t) { clearTimeout(t); timers.delete(item); }
  }
  function openPanel(item) {
    if (openItem && openItem !== item) closePanel(openItem);
    var p = parts(item);
    if (!p.panel) return;
    p.panel.hidden = false;
    item.classList.add('is-open');
    if (p.toggle) p.toggle.setAttribute('aria-expanded', 'true');
    openItem = item;
  }
  function closePanel(item) {
    clearTimer(item);
    var p = parts(item);
    if (!p.panel) return;
    p.panel.hidden = true;
    item.classList.remove('is-open');
    if (p.toggle) p.toggle.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }
  function closeAll() {
    document.querySelectorAll('[data-mjn-item].is-open').forEach(closePanel);
  }

  function bindDesktop(root) {
    root.querySelectorAll('[data-mjn-item]').forEach(function (item) {
      if (item.__mjnBound) return;
      item.__mjnBound = true;
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !desktopMq.matches || !hoverMq.matches) return;
        clearTimer(item);
        if (item.classList.contains('is-open')) return;
        timers.set(item, setTimeout(function () { openPanel(item); }, openItem ? 0 : OPEN_DELAY));
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimer(item);
        timers.set(item, setTimeout(function () { closePanel(item); }, CLOSE_DELAY));
      });
      var p = parts(item);
      if (p.toggle) {
        p.toggle.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimer(item);
          if (item.classList.contains('is-open')) closePanel(item);
          else openPanel(item);
        });
      }
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) closePanel(item);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openItem) return;
    var item = openItem;
    closePanel(item);
    var link = item.querySelector('.mjn__link');
    if (link && item.contains(document.activeElement)) link.focus();
  });
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) closeAll();
  });
  window.addEventListener('scroll', function () {
    if (openItem && window.scrollY > 0 && !openItem.matches(':hover')) closeAll();
  }, { passive: true });
  desktopMq.addEventListener && desktopMq.addEventListener('change', closeAll);

  /* ---------- Phone drawer ---------- */
  var drawer = null;
  var opener = null;
  var closing = false;

  function setOpeners(expanded) {
    document.querySelectorAll('[data-mjd-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function openDrawer(btn) {
    drawer = document.querySelector('[data-mjd]');
    if (!drawer || drawer.open) return;
    opener = btn || null;
    closeAll();
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    document.documentElement.classList.add('mjd-lock');
    setOpeners(true);
    drawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-visible'); });
    });
    var closeBtn = drawer.querySelector('[data-mjd-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function finishClose() {
    if (!drawer) return;
    if (typeof drawer.close === 'function' && drawer.open) drawer.close();
    else drawer.removeAttribute('open');
    document.documentElement.classList.remove('mjd-lock');
    setOpeners(false);
    closing = false;
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || !drawer.open || closing) return;
    closing = true;
    drawer.classList.remove('is-visible');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(finishClose, reduce ? 0 : 230);
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mjd-open]');
    if (openBtn) { e.preventDefault(); openDrawer(openBtn); return; }
    if (!drawer || !drawer.open) return;
    if (e.target.closest('[data-mjd-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target === drawer) { closeDrawer(); return; }
    var toggle = e.target.closest('[data-mjd-toggle]');
    if (toggle && drawer.contains(toggle)) {
      var sub = document.getElementById(toggle.getAttribute('aria-controls'));
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      drawer.querySelectorAll('[data-mjd-toggle][aria-expanded="true"]').forEach(function (t) {
        if (t === toggle) return;
        t.setAttribute('aria-expanded', 'false');
        var s = document.getElementById(t.getAttribute('aria-controls'));
        if (s) s.hidden = true;
      });
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (sub) sub.hidden = !willOpen;
      if (willOpen) {
        var body = drawer.querySelector('.mjd__body');
        var group = toggle.closest('[data-mjd-group]');
        if (body && group) {
          var top = group.offsetTop - 8;
          if (top < body.scrollTop || top > body.scrollTop + body.clientHeight * 0.4) {
            body.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      }
    }
  });
  document.addEventListener('cancel', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mjd]')) {
      e.preventDefault();
      closeDrawer();
    }
  }, true);
  desktopMq.addEventListener && desktopMq.addEventListener('change', function (mq) {
    if (mq.matches && drawer && drawer.open) finishClose();
  });

  /* ---------- Click tagging for Clarity ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mj-menu]');
    if (!a) return;
    var label = a.getAttribute('data-mj-menu') || '';
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'menu_item', label.slice(0, 120));
        window.clarity('event', 'menu_click');
      }
    } catch (err) { /* analytics must never block navigation */ }
  }, true);

  function init(root) { bindDesktop(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
